<template>
    <div class="ContenidoComponente">
        <apexcharts v-if="chartOptions != null"
            :type="type"
            :options="chartOptions"
            :series="series"
            class="EstilosGrafico"
        ></apexcharts>
        <br />
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { Herramientas } from "../../Auxiliares/Enums";

export default {
    name: "Grafico",
    components: {
        apexcharts: VueApexCharts,
    },
    watch: {
        DataEjeY: {
            // the callback will be called immediately after the start of the observation
            immediate: true,
            deep: true,
            handler(val, oldVal) {
                // do your stuff
                this.ActualizarGrafico();
            },
        },
    },
    data: function () {
        return {
            Records: {
                x: [],
                y: [],
            },
            //Grafico
            chartOptions: null,
            series: [
                {
                    name: this.TituloEjeX,
                    data: [],
                },
            ],
        };
    },
    props: {
        TituloEjeY: String,
        DataEjeX: Array,
        DataEjeY: Array,
        Acumulativo: Boolean,
        type: {
            type: String,
            default: "bar",
        },
        idHerramienta: {
            type: Number,
            default: 0,
        },
    },
    mounted() {
        this.ActualizarGrafico();
    },
    methods: {
        ActualizarGrafico() {
            this.SetRecords();
            this.SetChartOptions();
            this.SetSeries();
        },
        SetRecords() {
            this.Records.x = [];
            this.Records.y = [];
            if (this.idHerramienta != Herramientas.Freatimetros.id) {
                this.Records.x = this.DataEjeX;
                this.Records.y = this.DataEjeY;
                return;
            }
            let now = new Date();
            for (let i = 0; i < this.DataEjeX.length; i++) {
                const dateDDMMYYYY = this.DataEjeX[i];
                let dateParts = dateDDMMYYYY.split("/");
                let recordDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                if (now.getFullYear() == recordDate.getFullYear()) {
                    this.Records.x.push(recordDate.getTime());
                    this.Records.y.push(this.DataEjeY[i]);
                }
            }
        },
        SetChartOptions(){
            let chartOptionsAux = {
                chart: {
                    id: "basic-bar",
                    height: "350px",
                    toolbar: {
                        show: false,
                    }
                },
                xaxis: {
                    categories: this.Records.x,
                    labels: {
                        show: true,
                        rotate: -45,
                        rotateAlways: true,
                        minHeight: 50,
                    },
                },
                yaxis: {
                    title: {
                        text: "this.DataEjeY",
                    },
                    label: {
                        style: {
                            background: "#000",
                            color: "#777",
                            fontSize: "19px",
                            fontWeight: 400,
                        },
                    }
                },
                noData: {
                    text: "Aún no hay datos...",
                },
                tooltip: {
                    x: {
                        format: "dd MMM yyyy",
                    },
                },
                dataLabels: {
                    enabled: true,
                    offsetY: 0,
                    style: {
                        fontSize: "12px",
                        colors: ["#000"],
                    },
                    formatter: function (val) {
                        if (val <= -5) return "...";
                        return val;
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        dataLabels: {
                            position: "top",
                        },
                    },
                }
            };
            if (this.idHerramienta == Herramientas.Pluviometros.id){
                chartOptionsAux.yaxis.title.text = "mililitros";
            }
            if (this.idHerramienta == Herramientas.Freatimetros.id){
                let currentYear = new Date().getFullYear();
                chartOptionsAux.yaxis.title.text = "metros";
                chartOptionsAux.xaxis.type = "datetime";
                chartOptionsAux.xaxis.min = new Date(`01 Jan ${currentYear}`).getTime();
                chartOptionsAux.xaxis.max = new Date(`01 Jan ${currentYear + 1}`).getTime();
                chartOptionsAux.yaxis.max = 0;
                chartOptionsAux.yaxis.min = -5;
            }
            this.chartOptions = chartOptionsAux;
        },
        SetSeries(){
            if (this.Acumulativo) {
                let [newSerie, total] = [[], 0];
                this.Records.y.forEach(rec => {
                    total += rec;
                    newSerie.push(total);
                });
                this.series = [
                    {
                        name: "Individual",
                        data: this.Records.y,
                    },
                    {
                        name: "Acumulativo",
                        data: newSerie,
                    },
                ];
            } else {
                this.series = [
                    {
                        name: "Altura napa",
                        data: this.Records.y,
                    },
                ];
            }
        }
    },
};
</script>


<style lang="scss" scoped>
.ContenidoComponente {
    display: flex;
    align-items: center;
    justify-content: center;
}
.EstilosGrafico {
    width: calc(100% - 20px);
    max-width: 800px;
}
@media (max-width: 360px) {
    .EstilosGrafico {
        width: calc(100% - 10px);
        max-width: 360px;
    }
}
</style>
